import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { HotelCard_Loading } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./HotelListItem.module.scss";

export type HotelListItemLoadingProps = PlatformComponentProps;

export const HotelListItem_Loading = ({
  className,
}: HotelListItemLoadingProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelListItem,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelListItem);

  return (
    <div className={clsx(block, className)}>
      <HotelCard_Loading />
    </div>
  );
};
